import React, { useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';

import LinkElement from './LinkElement';

import useNavLinks from './hooks/useNavLinks';
import { useUiStore } from '../../../store';
import useResizeObserver from '../../../hooks/useResizeObserver';

export default function SecondarySidebar({ isSecondarySidebarOpen }) {
  const sidebarRef = useRef();

  const { id } = useParams();

  const { width } = useResizeObserver(sidebarRef);

  const setSidebarWidth = useUiStore((state) => state.setSidebarWidth);
  const secondarySidebarLinks = useUiStore(
    (state) => state.secondarySidebarLinks
  );

  const links = useNavLinks();

  const currentLinks = secondarySidebarLinks.length
    ? secondarySidebarLinks
    : links;

  useEffect(() => {
    setSidebarWidth(isSecondarySidebarOpen ? width + 64 + 24 : 64);
  }, [setSidebarWidth, width, isSecondarySidebarOpen]);

  return (
    <div
      ref={sidebarRef}
      id="secondary-sidenav"
      className="overflow-y-auto py-5 px-3 w-64 h-full bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700 transition-transform left-0 top-0 transform-none"
    >
      <ul className="space-y-2">
        {currentLinks.map((link) => {
          return (
            <li key={link.createLink ? link.createLink(id) : link.url}>
              {link.disabled ? (
                <span className="flex items-center p-2 text-base font-medium text-gray-400 cursor-not-allowed rounded-lg">
                  {link.title}
                </span>
              ) : (
                <LinkElement link={link} />
              )}
            </li>
          );
        })}
      </ul>

      <div className="flex absolute -left-4 bottom-16 z-20 justify-end w-full bg-white dark:bg-gray-800">
        <button
          id="show-secondary-sidenav-button"
          aria-controls="secondary-sidenav"
          type="button"
          className="inline-flex p-2 text-gray-500 rounded-full cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );
}
